import type { IBaseAdmin } from "../../BaseAdminFactory";
import type { OfficeRole } from "le-coffre-resources/dist/Admin";
import type { QueryPayload } from "@Front/Api/types";
import type { IGetRolesParams, IPutRoleParams, IPostRoleParams } from "../OfficeRoles";
import {
	buildOfficeRolesCreatePayload,
	buildOfficeRolesUpdatePayload,
} from "@Front/Api/LeCoffreApi/helpers/businessRequestPayloadHelpers";

export function createGetMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (q?: IGetRolesParams): Promise<OfficeRole[]> => {
		const url = new URL(baseUrl);
		if (q) {
			baseAdmin.appendJsonSearchParams(url, { q });
		}
		try {
			return await baseAdmin.getRequest<OfficeRole[]>(url);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createGetByUidMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string, q?: QueryPayload): Promise<OfficeRole> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		if (q) baseAdmin.appendJsonSearchParams(url, q);
		try {
			return await baseAdmin.getRequest<OfficeRole>(url);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPutMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string, body: IPutRoleParams): Promise<OfficeRole> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		try {
			const payload = buildOfficeRolesUpdatePayload(body);
			return await baseAdmin.putRequest<OfficeRole>(url, payload);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPostMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (body: IPostRoleParams): Promise<OfficeRole> => {
		const url = new URL(baseUrl);
		try {
			const payload = buildOfficeRolesCreatePayload(body);
			return await baseAdmin.postRequest<OfficeRole>(url, payload);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createDeleteMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string): Promise<OfficeRole> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		try {
			return await baseAdmin.deleteRequest<OfficeRole>(url);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}
